// Pinned by common-contracts/album_access.json (see albumAccess.test.ts).
export const ALBUM_ACCESS_VALUES = ['open', 'registered'] as const;
export type AlbumAccess = (typeof ALBUM_ACCESS_VALUES)[number];
export const DEFAULT_ALBUM_ACCESS: AlbumAccess = 'open';

/** Absent or unknown values read as the default ('open'). */
export const readAlbumAccess = (v: unknown): AlbumAccess =>
  (ALBUM_ACCESS_VALUES as readonly unknown[]).includes(v) ? (v as AlbumAccess) : DEFAULT_ALBUM_ACCESS;
